export default __webpack_public_path__ + "static/media/opensea.6706f228.svg";